import React from 'react';
import { Link } from '../Link.jsx';
import AuthorizedAction from '../AuthorizedAction.js';
import { getOrgSlug } from '../../lib/utils.js';

export const NewFileLink = ({
  projectId,
  initiativeProjectId,
  initiative,
  ...props
}) => {
  const params = {
    projectId,
    initiativeProjectId,
    slug: getOrgSlug(),
  };

  if (initiative) {
    params.initiativeId = initiative.id;
    params.initiativeType = initiative.type;
  }

  return (
    <AuthorizedAction action="create" subject="linkedFile">
      <Link route="files/new" params={{ ...params }} {...props} />
    </AuthorizedAction>
  );
};

export const EditFileLink = ({ fileId, ...props }) => (
  <AuthorizedAction action="update" subject="linkedFile">
    <Link
      route="files/edit"
      params={{ fileId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);
